import styled from "styled-components";

export const DSRMerchandisingSectionMobile = styled.div`
  display: none;
  @media (max-width: ${(props) => props.breakpoint}px) {
    display: block;
  }
`;

export const DSRMerchandisingSection = styled.div`
  display: none;
  @media (min-width: ${(props) => props.breakpoint}px) {
    display: block;
  }
`;
